import React from "react";
import { FlexContainer, LottieLoadingIndicator, Text } from "src/components";
import SurveyRatingCard from "./SurveyRatingCard";
import SurveySatisfactionCard from "./SurveySatisfactionCard";
import SurveyYesNoCard from "./SurveyYesNoCard";
import { SurveyFeedbackCard } from "./SurveyFeedbackCard";
import { EnumSurveyType, getQuestionSurveyType } from "../Enums";
import { SurveyStatusType } from "src/constants/survey";
import { RealTimeBadge } from "../RealTimeBadge";

const surveyTypeIdentifier = (surveyType, survey, surveyQuestion, numberOfUsersInTargetGroup, responsesStats, fetchingResponseStats, user) => {
    if (fetchingResponseStats) {
        return <LottieLoadingIndicator/>;
    }
    switch (surveyType) {
        case EnumSurveyType.YESNO:
            return <SurveyYesNoCard surveyQuestion={surveyQuestion} numberOfUsersInTargetGroup={numberOfUsersInTargetGroup} responsesStats={responsesStats} fetchingResponseStats={fetchingResponseStats}/>;
        case EnumSurveyType.FEEDBACK:
            return <SurveyFeedbackCard surveyQuestion={surveyQuestion} responsesStats={responsesStats} fetchingResponseStats={fetchingResponseStats} user={user} survey={survey} />;
        case EnumSurveyType.RATING:
            return <SurveyRatingCard surveyQuestion={surveyQuestion} responsesStats={responsesStats} fetchingResponseStats={fetchingResponseStats} />;
        case EnumSurveyType.SATISFACTION:
            return <SurveySatisfactionCard surveyQuestion={surveyQuestion} responsesStats={responsesStats} fetchingResponseStats={fetchingResponseStats} />;
        default:
            break;
    }
};

const SurveyQuestions = (props) => {
    const { insights, surveyType, survey, responsesStats, fetchingResponseStats, user } = props;
  
    return (
        <>
            {insights.surveyQuestions && insights.surveyQuestions.map((question, index) => (
                <React.Fragment key={`SurveyQuestionItem_${question.uuid}`}>
                    <FlexContainer direction="row" mDirection="row" tDirection="row" justifyContent="space-between">
                        <div style={{ width: "650px", wordWrap: "break-word", wordBreak: "break-all" }}>
                            <Text color="#000" size="20px" weight="bold" align="left" margin="20px 0 10px 0">
                                {`Question ${question.questionOrder}`}
                            </Text>
                            <Text color="#000" weight="500" size="15px" align="left" margin="0 0 15px 0">
                                {question.question}
                            </Text>
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            {survey.status === SurveyStatusType.ACTIVE && (
                                <RealTimeBadge />
                            )}
                        </div>
                    </FlexContainer>
                    {surveyTypeIdentifier(getQuestionSurveyType(survey, question) || surveyType, survey, question, insights.numberOfUsersInTargetGroup, responsesStats, fetchingResponseStats, user)}
                </React.Fragment>
            ))}
            {!insights.surveyQuestions && (
                <Text>No survey questions available.</Text>
            )}
        </>
    );
};

export default SurveyQuestions;
